
















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LayoutLoading extends Vue {

}
